<template>
    <div class="landing-right">
        <div class="step-indicator">
            <div class="step-wrapper">
                <div :class="$store.state.landingpage.activeLanding == 'instruction'
                    ? 'step-number-white'
                    : 'step-number-red'
                    " @click="jumpTo('instruction')">
                    1
                </div>
                <div class="step-hr-start"></div>
                <div class="step-name">Registrasi</div>
            </div>
            <div class="step-wrapper">
                <div @click="jumpTo('profiles')" :class="$store.state.landingpage.activeLanding == 'profile' ||
                    $store.state.landingpage.activeLanding == 'profilebu'
                    ? 'step-number-white'
                    : 'step-number-red'
                    ">
                    2
                </div>
                <div class="step-hr-mid"></div>
                <div class="step-name">Profil</div>
            </div>
            <div class="step-wrapper">
                <div @click="jumpTo('alamat')" :class="$store.state.landingpage.activeLanding == 'alamat' ||
                    $store.state.landingpage.activeLanding == 'alamatbu'
                    ? 'step-number-white'
                    : 'step-number-red'
                    ">
                    3
                </div>
                <div class="step-hr-mid"></div>
                <div class="step-name">Alamat</div>
            </div>
            <div class="step-wrapper">
                <div @click="jumpTo('bank')" :class="$store.state.landingpage.activeLanding == 'bank' ||
                    $store.state.landingpage.activeLanding == 'bankbu'
                    ? 'step-number-white'
                    : 'step-number-red'
                    ">
                    4
                </div>
                <div class="step-hr-mid"></div>
                <div class="step-name">Bank</div>
            </div>
            <div class="step-wrapper">
                <div @click="jumpTo('afiliasi')" :class="$store.state.landingpage.activeLanding == 'afiliasi' ||
                    $store.state.landingpage.activeLanding == 'afiliasibu'
                    ? 'step-number-white'
                    : 'step-number-red'
                    ">
                    5
                </div>
                <div class="step-hr-mid"></div>
                <div class="step-name">Afiliasi</div>
            </div>
            <div class="step-wrapper">
                <div @click="jumpTo('legaldoc')" :class="$store.state.landingpage.activeLanding == 'legalitas' ||
                    $store.state.landingpage.activeLanding == 'legalitasbu'
                    ? 'step-number-white'
                    : 'step-number-red'
                    ">
                    6
                </div>
                <div class="step-hr-mid"></div>
                <div class="step-name">Dokumen Legal</div>
            </div>
            <div class="step-wrapper">
                <div @click="jumpTo('selesai')" :class="$store.state.landingpage.activeLanding == 'selesai'
                    ? 'step-number-white'
                    : 'step-number-red'
                    ">
                    7
                </div>
                <div class="step-hr-end"></div>
                <div class="step-name">Selesai</div>
            </div>
        </div>
        <div class="landing-form">
            <div class="landing-box">
                <!-- <router-view /> -->
                <keep-alive>
                    <component :is="activeLanding" />
                </keep-alive>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        activeLanding: function () {
            const tab = this.$store.state.landingpage.activeLanding

            switch (tab) {
                case 'instruction':
                    return () => import('@/views/LandingPage/Instruction.vue')
                    break
                case 'profilebu':
                    return () => import('@/views/LandingPage/ProfilBU.vue')
                    break
                case 'alamat':
                    return () => import('@/views/LandingPage/Alamat.vue')
                    break
                case 'bank':
                    return () => import('@/views/LandingPage/Bank.vue')
                    break
                case 'afiliasi':
                    return () => import('@/views/LandingPage/Afiliasi.vue')
                    break
                case 'legalitas':
                    return () => import('@/views/LandingPage/Legalitas.vue')
                    break
                case 'legalitasbu':
                    return () => import('@/views/LandingPage/LegalitasBU.vue')
                    break
                case 'selesai':
                    return () => import('@/views/LandingPage/Selesai.vue')
                    break
                default:
                    break
            }
        },
    },
    methods: {
        jumpTo(name) {
            const {
                query,
                start_step,
                profil_step,
                alamat_step,
                bank_step,
                afiliasi_step,
                legal_step,
                end_step,
            } = this.$store.state.landingpage

            if (name == 'instruction') {
                if (start_step) {
                    this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'instruction')
                } else {
                    this.sendNotif()
                }
            }

            if (name == 'profiles') {
                if (profil_step) {
                    this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'profilebu')
                } else {
                    this.sendNotif()
                }
            }

            if (name == 'alamat') {
                if (alamat_step) {
                    this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'alamat')
                } else {
                    this.sendNotif()
                }
            }
            if (name == 'bank') {
                if (bank_step) {
                    this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'bank')
                } else {
                    this.sendNotif()
                }
            }
            if (name == 'afiliasi') {
                if (afiliasi_step) {
                    this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'afiliasi')
                } else {
                    this.sendNotif()
                }
            }
            if (name == 'legaldoc') {
                if (legal_step) {
                    if (query == 'bu')
                        this.$store.commit(
                            'landingpage/SET_LANDINGPAGE_FORM',
                            'legalitasbu'
                        )
                    if (query == 'perorangan')
                        this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'legalitas')
                } else {
                    this.sendNotif()
                }
            }
            if (name == 'selesai' && end_step) {
                if (end_step) {
                    this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'selesai')
                } else {
                    this.sendNotif()
                }
            }
        },
        sendNotif() {
            this.$store.commit(
                'SET_NOTIF',
                'Selesaikan Step Sebelumnya Terlebih Dahulu.'
            )
        },
    }
}
</script>
